import tracking from 'dibs-tracking';
import { getPromoCreative } from '../../helpers/getPromoCreative';

function buildItemTrackingObject({ index, url }) {
    const position = index + 1;
    return {
        id: `promo-tile-${position}`,
        name: `Promo Tile #${position}`,
        creative: getPromoCreative(url),
        position: position,
    };
}

function trackPromoImpressions({ items, startingIndex }) {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: items.map((item, index) =>
            buildItemTrackingObject({ index: index + startingIndex, url: item.link })
        ),
    });
}

function trackPromoClick({ item, index }) {
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [buildItemTrackingObject({ index, url: item.link })],
    });
}

export { trackPromoImpressions, trackPromoClick };
